import { Checkbox, HStack, Skeleton } from '@chakra-ui/react';
import CustomDataTableEditBtn from '@Modules/core/components/table/CustomDataTableEditBtn';
import CustomDataTableInfoBtn from '@Modules/core/components/table/CustomDataTableInfoBtn';
import { createColumnHelper } from '@tanstack/react-table';

export type TCardAccountLinkDataTableData = {
  primaryKey: string | number,
  bankAccount: string | number,
  bankAccountType: string,
  chequeBook: string,
  pan: {
    pan1: string,
    pan2: string,
    pan3: string,
    pan4: string,
    pan5: string,
    [x: string]: any,
  },
  customer: {
    name: string,
    unknown: string,
    [x: string]: any,
  },
  [x: string]: any,
};

export type TAction = 'info' | 'edit';

type Props = {
  isLoading: boolean | undefined,
  handleDataTableBtn: (row: any, action: TAction) => void,
};

const columnHelper = createColumnHelper<TCardAccountLinkDataTableData>();

export function getCardAccountLinkDataTableColumns({
  isLoading,
  handleDataTableBtn,
}: Props) {
  return [
    columnHelper.accessor('bankAccount', {
      id: 'bankAccount',
      header: 'Compte Bancaire',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('bankAccountType', {
      id: 'bankAccountType',
      header: 'Type Compte Bancaire',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('chequeBook', {
      id: 'chequeBook',
      header: 'Livre Chèque',
      cell: (props) => {
        return (
          <Skeleton isLoaded={!isLoading}>
            <Checkbox checked={!!props.getValue()} readOnly></Checkbox>
          </Skeleton>
        );
      },
    }),

    columnHelper.accessor('pan.pan1', {
      id: 'pan1',
      header: '',
      cell: '',
      enableHiding: false,
    }),

    columnHelper.accessor('pan.pan2', {
      id: 'pan2',
      header: '',
      cell: '',
      enableHiding: false,
    }),

    columnHelper.accessor('pan.pan3', {
      id: 'pan3',
      header: '',
      cell: '',
      enableHiding: false,
    }),

    columnHelper.accessor('pan.pan4', {
      id: 'pan4',
      header: '',
      cell: '',
      enableHiding: false,
    }),

    columnHelper.accessor('pan.pan5', {
      id: 'pan5',
      header: '',
      cell: '',
      enableHiding: false,
    }),

    columnHelper.accessor('customer.name', {
      id: 'name',
      header: '',
      cell: '',
      enableHiding: false,
    }),

    columnHelper.accessor('customer.unknown', {
      id: 'unknown',
      header: '',
      cell: '',
      enableHiding: false,
    }),

    columnHelper.display({
      id: 'action',
      header: '',
      cell: (props) => {
        return (
          <HStack>
            <CustomDataTableEditBtn
              disabled={isLoading}
              onClick={() => handleDataTableBtn(props.row, 'edit')}
            />
            <CustomDataTableInfoBtn
              disabled={isLoading}
              onClick={() => handleDataTableBtn(props.row, 'info')}
            />
          </HStack>
        );
      },
    }),
  ];
}
